"use client";

import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import Link from "next/link";
import { NavUser } from "./nav-user";
import { UserOrNot } from "./user-or-not";
import { ModeToggle } from "@/components/light-dark-toggle";
import { ContactFormDialog } from "@/components/contact-form-dialog";
import { useLoginLabel } from "@/hooks/use-login-label";

function NoUserContent() {
  const [contactOpen, setContactOpen] = useState(false);
  const loginLabel = useLoginLabel();

  return (
    <div className="flex items-center gap-4 justify-center animate-in fade-in duration-500">
      <ModeToggle />
      <Button variant="outline" onClick={() => setContactOpen(true)}>
        Book a Call
      </Button>
      <ContactFormDialog open={contactOpen} onOpenChange={setContactOpen} />
      <Button asChild>
        <Link
          prefetch
          href={{ pathname: "/login", query: { redirectTo: "/me/api-keys" } }}
        >
          {loginLabel}
        </Link>
      </Button>
    </div>
  );
}

export function LoginOrUserDesktop() {
  return (
    <UserOrNot
      userContent={(user) => (
        <div className="flex items-center gap-2">
          <ModeToggle />
          <NavUser user={user} />
        </div>
      )}
      noUserContent={<NoUserContent />}
    />
  );
}
